import {FetchService} from "cronus-theme/default/global/ts/fetch.service";
import {H5P} from 'h5p-standalone';

const H5P_STATE = {
    LOADING: 'h5p--loading',
    ERROR: 'h5p--error',
    LOADED: 'h5p--loaded'
};

function createLoader() {
    const loader = document.createElement('div');
    loader.className = 'h5p-loader';
    loader.innerHTML = `
        <div class="h5p-loader__spinner"></div>
        <span class="h5p-loader__text">Inhalt wird geladen...</span>
    `;
    return loader;
}

function createErrorMessage(message = 'Inhalt konnte nicht geladen werden.') {
    const error = document.createElement('div');
    error.className = 'h5p-error';
    error.innerHTML = `<span class="h5p-error__text">${message}</span>`;
    return error;
}

function setState(container, state) {
    Object.values(H5P_STATE).forEach(s => container.classList.remove(s));
    container.classList.add(state);
}

async function loadH5pFromEmService(id) {
    const fetchData = await FetchService.get(`/em/h5pContentRouter/getH5PContentScript/${id}`);
    if (fetchData.success) {
        return JSON.parse(fetchData.data);
    }
    return null;
}

function loadCssFile(cssPath) {
    if (!cssPath) return;
    if (document.querySelector(`link[href="/${cssPath}"]`)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/' + cssPath;
    document.head.appendChild(link);
}

async function renderH5pContent(container, h5pData) {
    if (h5pData.cssFile) {
        loadCssFile(h5pData.cssFile);
    }

    if (!h5pData.contentPath) {
        throw new Error('contentPath missing');
    }

    const options = {
        h5pJsonPath: '/' + h5pData.contentPath,
        frameJs: '/layout/frontend/bvg/dist/js/h5p/frame.bundle.js',
        frameCss: '/layout/frontend/bvg/dist/css/h5p/h5p.css',
        embedType: 'div'
    };

    await new H5P(container, options);
}

async function loadH5pContainer(container) {
    const id = container.dataset.id;
    if (!id || container.dataset.h5pInitialized) return;

    container.dataset.h5pInitialized = 'true';

    const loader = createLoader();
    container.appendChild(loader);
    setState(container, H5P_STATE.LOADING);

    try {
        const data = await loadH5pFromEmService(id);

        if (!data || !data.contentPath) {
            throw new Error('Keine Daten erhalten');
        }

        loader.remove();
        await renderH5pContent(container, data);
        setState(container, H5P_STATE.LOADED);
    } catch (error) {
        console.error('H5P load error:', error);
        loader.remove();
        container.appendChild(createErrorMessage());
        setState(container, H5P_STATE.ERROR);
    }
}

export function initH5pLoader(wrapper = document) {
    const containers = wrapper.querySelectorAll('.h5pContainer');
    containers.forEach(container => loadH5pContainer(container));
}